//Panel
import PrivacyPolitics from "./containers/public/politicas/PrivacyPolitics";
import ProcesoMatriculacion from "./containers/public/process/ProcessMatriculation";
import ProcessView from "./containers/public/process/ProcessView";


const publicRoutes = [
    {
        path: "/politica_privacidad",
        component: PrivacyPolitics,
    },
    {
        path: "/inicio",
        component: ProcessView,
    },
    {
        path: "/proceso_matriculacion/:ci_estudiante",
        component: ProcesoMatriculacion,
    },

];

export default publicRoutes;
